import React from 'react';
import PropTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { TabelaLancamentos } from './styles';

function StatementEntriesTable({ entries }) {
  if (!entries || entries.length === 0) {
    return null;
  }

  return (
    <TabelaLancamentos>
      <thead>
        <tr>
          <th
            className="left-align"
            rowSpan="2"
            style={{ paddingLeft: '5px' }}
          >
            Código
          </th>
          <th
            className="left-align"
            rowSpan="2"
          >
            Descrição do Lançamento
          </th>
          <th
            className="bordered"
            colSpan="2"
            width="20%"
            style={{ borderTop: 'none' }}
          >
            Créditos
          </th>
          <th
            className="bordered"
            colSpan="2"
            width="20%"
            style={{ borderTop: 'none', borderRight: 'none' }}
          >
            Débitos
          </th>
        </tr>
        <tr>
          <th
            className="bordered"
            width="10%"
          >
            Atual
          </th>
          <th
            className="bordered"
            width="10%"
          >
            Acumulado
          </th>
          <th
            className="bordered"
            width="10%"
          >
            Atual
          </th>
          <th
            className="bordered"
            width="10%"
            style={{ borderRight: 'none' }}
          >
            Acumulado
          </th>
        </tr>
      </thead>
      <tbody>
        {entries.map((lancamento) => (
          <tr key={lancamento.codigo}>
            <td
              className="left-align"
              style={{ paddingLeft: '5px' }}
            >
              {lancamento.codigo}
            </td>
            <td className="left-align">{lancamento.descricao}</td>
            <td className="right-align">{moneyFormat(lancamento.creditoAtual)}</td>
            <td className="right-align">{moneyFormat(lancamento.creditoAcumulado)}</td>
            <td className="right-align">{moneyFormat(lancamento.debitoAtual)}</td>
            <td
              className="right-align"
              style={{ paddingRight: '5px' }}
            >
              {moneyFormat(lancamento.debitoAcumulado)}
            </td>
          </tr>
        ))}
      </tbody>
    </TabelaLancamentos>
  );
}

StatementEntriesTable.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string,
      descricao: PropTypes.string,
      creditoAtual: PropTypes.number,
      creditoAcumulado: PropTypes.number,
      debitoAtual: PropTypes.number,
      debitoAcumulado: PropTypes.number,
    })
  ),
};

StatementEntriesTable.defaultProps = {
  entries: undefined,
};

export default StatementEntriesTable;
